import Splide from '@splidejs/splide';

export const init = () => {
  initCarousel();
  const chatboxQuestions = document.querySelector('.s-mia-chatbox__questions');

  if (chatboxQuestions) {
    const observer = new MutationObserver(() => {
      initCarousel();
    });

    observer.observe(chatboxQuestions, { childList: true });
  }
};

function initCarousel() {
  const carouselContainers = document.querySelectorAll('.carousel_type-11');

  if (carouselContainers.length === 0) return;

  carouselContainers.forEach((container) => {
    const splideCarousel = new Splide(container, {
      arrows: false,
      pagination: false,
      autoplay: false,
      interval: 2000,
      gap: 32,
      perPage: 3,
      perMove: 3,
      drag: true,
      breakpoints: {
        1055: { perPage: 2, perMove: 1 },
        671: { perPage: 1, perMove: 1, padding: 0 },
      },
    });

    splideCarousel.mount();

    const arrowLeft = container.querySelector('.btn--prev-1');
    const arrowRight = container.querySelector('.btn--next-1');
    const controller = splideCarousel.Components.Controller;

    splideCarousel.on('move', (newIndex) => {
      const isAtStart = newIndex === 0;
      const isAtEnd = newIndex === controller.getEnd();

      arrowLeft.classList.toggle('disabled', isAtStart);
      arrowRight.classList.toggle('disabled', isAtEnd);
    });

    arrowLeft.addEventListener('click', () => splideCarousel.go('<'));
    arrowRight.addEventListener('click', () => splideCarousel.go('>'));
    
    const hideArrowsIfNeeded = () => {
      const hideArrows = splideCarousel.length <= splideCarousel.options.perPage;
      arrowLeft.classList.toggle('hidden', hideArrows);
      arrowRight.classList.toggle('hidden', hideArrows);
    };

    hideArrowsIfNeeded();
    splideCarousel.on('refresh', hideArrowsIfNeeded);
  });
}


